import React from 'react';

import { useTranslation } from 'app/lang';

import { TimeFilterUI } from './components/TimeFilterUI';
import { timeFilterTabItemAll } from './constants';
import { PREMATCH_FILTERS_FROM_BACK } from './stubs';
import { getTabs } from './utils/get-tabs/get-tabs';

type TimeFilterProps = {
  className?: string;
};

export const TimeFilter = ({ className }: TimeFilterProps) => {
  const { t } = useTranslation();
  const tabsItems = PREMATCH_FILTERS_FROM_BACK && getTabs({
    t,
    prematchFilterFromBack: PREMATCH_FILTERS_FROM_BACK,
    extraFilters: {
      pop: [timeFilterTabItemAll],
    },
  });

  if (!tabsItems) {
    return null;
  }

  const tabs = {
    items: tabsItems,
    defaultActiveId: timeFilterTabItemAll.id,
  };

  return (
    <TimeFilterUI className={className}
                  tabs={tabs} />
  );
};
